import { render, staticRenderFns } from "./PageBriefNew.vue?vue&type=template&id=33b8d4c3&scoped=true&lang=pug&"
import script from "./PageBriefNew.vue?vue&type=script&lang=js&"
export * from "./PageBriefNew.vue?vue&type=script&lang=js&"
import style0 from "./PageBriefNew.vue?vue&type=style&index=0&id=33b8d4c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b8d4c3",
  null
  
)

export default component.exports